[].forEach.call(document.getElementsByClassName('info'), (i) => {
	i.addEventListener('click', (e) => {
		e.preventDefault();
		i.classList.toggle('active');
		document.body.classList.toggle('info-active');
		document.getElementsByClassName('information')[0].classList.toggle('active')
		if (document.body.classList.contains('showall')){
			document.body.classList.remove('showall');
			const sliders = document.querySelectorAll('.slider');
			[].forEach.call(sliders, (slider) => {
				slider.classList.remove('showall');
			});
		}
	})
});